import React from "react";
import Loader from "../loader";

import "./styles.css";

const DefaultButton = ({
  size = "large",
  width = "max",
  radius = "rounded-[0.75em]",
  disabled = false,
  loading = false,
  children,
  title,
  ...props
}) => {
  const sizeClasses = {
    extraSmall: "text-[0.75em] px-[1.5625em] py-[0.75em]",
    small: "text-[0.75em] px-[2.0625em] py-[0.6875em]",
    medium: "text-[0.875em] px-[2.4375em] py-[0.875em]",
    large: "text-[1.125em] px-[2.8125em] py-[1em]",
  };
  const radiusClasses = {
    none: "rounded-none",
    small: "rounded-sm",
    medium: "rounded-md",
    large: "rounded-lg",
    xl: "rounded-xl",
    full: "rounded-full",
  };
  const widthClasses = {
    max: "w-max",
    fifty: "w-[50%]",
    full: "w-full",
  };

  const buttonSize = sizeClasses[size] || sizeClasses.large;
  const borderRadius = radiusClasses[radius] || "rounded-[0.75em]";
  const widthStyle = widthClasses[width] || "w-max";

  return (
    <button
      {...props}
      className={`bg-main text-white button-font hover:drop-shadow-lg transition-all capitalize ${buttonSize} ${borderRadius} ${widthStyle} whitespace-nowrap overflow-hidden text-ellipsis ${
        disabled && "opacity-80 cursor-not-allowed"
      }`}
      title={title ?? children}
      disabled={disabled}
    >
      {children}
      {loading && (
        <span className="ml-2">
          <Loader.ButtonLoader />
        </span>
      )}
    </button>
  );
};

export default DefaultButton;
